import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { 
  NotificationType, 
  NotificationTypeDDL,
  SendTypeDDL
} from "@/views/sidebar/notification/notification.type";
import { ClientDDL } from "@/views/base/base.types";

@Component({
  computed: {
    ...mapState("Notification", [
      "notificationTypes",
      "notificationTypeDDL",
      "selectedNotificationTypeDDL",
      "sendTypeDDL",
      "selectedSendTypeDDL"
    ]),
    ...mapState("Base", [
      "selectedClientDDL"
    ]),
  }
})
export default class NotificationMixin extends Vue {
  notificationTypes!: NotificationType[];
  notificationTypeDDL!: NotificationTypeDDL[];
  selectedNotificationTypeDDL!: NotificationTypeDDL;
  selectedClientDDL!: ClientDDL;
  sendTypeDDL!: SendTypeDDL[];
  selectedSendTypeDDL!: SendTypeDDL;

  get selectedNotificationType() {
    return this.notificationTypes.find(
      item => item.name === this.selectedNotificationTypeDDL.text
    ) ?? new NotificationType;
  }
}